import { SCOPES } from 'constants/roles';

export default [
  {
    label: 'label.diets',
    name: 'diets-list',
    url: '/professional/programs/diets/',
    navigationIcon: 'far fa-calendar-alt',
    scope: SCOPES.CREATOR,
    pages: [
      {
        type: 'section',
        navigationIcon: 'far fa-clipboard-list',
        name: 'diet-basic-information',
        label: 'label.diet_details',
        url: '/professional/programs/diets/{id}/main-information',
        pages: [
          {
            type: 'item',
            navigationIcon: '',
            name: 'diet-basic-information',
            url: '/professional/programs/diets/{id}/main-information/basic',
            label: 'label.main_information',
          },
          {
            type: 'item',
            navigationIcon: 'far fa-calendar-alt',
            name: 'diet-schedules',
            url: '/professional/programs/diets/{id}/main-information/schedules/{dayID}',
            label: 'label.schedules',
          },
          {
            type: 'item',
            navigationIcon: '',
            name: 'diet-cover-image',
            url: '/professional/programs/diets/{id}/main-information/cover-image',
            label: 'label.program_cover',
          },
          // {
          //   type: 'item',
          //   navigationIcon: '',
          //   name: 'diet-health-related-semantic',
          //   url: '/professional/programs/diets/{id}/main-information/health-related-semantic',
          //   label: 'label.health_related_semantic',
          // },
        ],
      },
      // {
      //   label: 'label.schedules',
      //   navigationIcon: 'far fa-calendar-alt',
      //   name: '',
      //   type: 'section',
      //   url: '/professional/programs/diets/{id}/schedules',
      //   scope: SCOPES.PROFESSIONAL,
      //   pages: [
      //     {
      //       type: 'item',
      //       navigationIcon: 'far fa-calendar-alt',
      //       name: 'diet-schedules',
      //       url: '/professional/programs/diets/{id}/schedules/{dayID}',
      //       label: 'label.schedules',
      //     },
      //   ],
      // },
      {
        label: 'label.settings',
        navigationIcon: 'far fa-cog',
        name: 'diet-settings-status',
        type: 'section',
        url: '/professional/programs/diets/{id}/settings',
        scope: SCOPES.CREATOR,
        pages: [
          {
            type: 'item',
            navigationIcon: 'far fa-shield-alt',
            name: 'diet-settings-status',
            url: '/professional/programs/diets/{id}/settings/status',
            label: 'label.status',
          },
          {
            type: 'item',
            class: 'is-delete',
            navigationIcon: 'far fa-trash-alt',
            name: 'diet-settings-delete',
            url: '/professional/programs/diets/{id}/settings/delete',
            label: 'label.delete_program',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/navigations/program/navigation-program-diet.js